import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import useNotaFiscalPesquisar from '../../../../hooks/useNotaFiscalPesquisar';
import * as Icon from '@mui/icons-material';
import FormBuilder from '../../../../shared/components/FormBuilder';
import { ModalCancelar } from './ModalCancelar';
import { Button } from '../../../../shared/components/button/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import { ModalRelatorio } from '../../../../shared/components/ModalRelatorio';

const fields = [
  { name: 'NumeroNotaFiscal', type: 'number', label: 'Número NF', col: 3 },
  {
    name: 'Status',
    type: 'select',
    /* [23/10/2026] Os VALORES sao as palavras que o banco guarda, letra por letra.
       Antes nao eram: a lista oferecia 'Finalizado', 'Cancelado' e 'Error', e a coluna
       nf_status guarda 'Transmitida', 'Cancelada' e 'Rejeitada'. A procedure compara
       as duas cruas (`nf_status = @p_status`), entao escolher 'Cancelado' nunca achava
       uma nota sequer - e o usuario concluia que o filtro estava quebrado, sem jeito de
       descobrir que a palavra e que estava errada.

       As cinco palavras saem do proprio banco de producao (consulta de 23/10):
       Transmitida 954, Cancelada 51, Rejeitada 15, Nao Transmitida 10, Processando 1.
       Mexer aqui sem conferir la devolve o defeito.

       O `label` pode ser mais amigavel que o `value` - e o que acontece em Rejeitada,
       que a tela chama de 'Rejeitada pela SEFAZ'. O que nao pode divergir e o value. */
    options: [
      {
        value: 'Transmitida',
        label: 'Transmitida',
      },
      {
        value: 'Cancelada',
        label: 'Cancelada',
      },
      {
        value: 'Rejeitada',
        label: 'Rejeitada pela SEFAZ',
      },
      {
        value: 'Não Transmitida',
        label: 'Não Transmitida',
      },
      {
        value: 'Processando',
        label: 'Processando',
      },
      {
        value: 'Todos',
        label: 'Todos',
      },
    ],
    label: 'Status',
    col: 3,
  },
  { name: 'Nome', type: 'text', label: 'Cliente', col: 4 },
  { name: 'DataInicio', type: 'date', label: 'Data Início', col: 3 },
  { name: 'DataFim', type: 'date', label: 'Data Fim', col: 3 },
  { type: 'submit', icon: <Icon.Search style={{ fontSize: '28px' }} /> },
];

export default function Cliente() {
  const {
    columns,
    rows,
    loading,
    onSubmit,
    formRef,
    modalCancelarCartaCorrecao,
    handleCloseModalCancelar,
    formCancelarCartaCorrecao,
    modalTitulo,
    downloadRelatorio,
    loadingRelatorio,
    modalRelatorioAberto,
    fecharModalRelatorio,
    gerarRelatorioFaturamento,
    periodoSugerido,
    setores,
    downloadXmls,
    loadingXmls,
  } = useNotaFiscalPesquisar();

  return (
    <Loader loading={loading}>
      <Box>
        <ModalCancelar
          open={modalCancelarCartaCorrecao}
          onClose={handleCloseModalCancelar}
          formCancelarCartaCorrecao={formCancelarCartaCorrecao}
          modalTitulo={modalTitulo}
        />
        {/* [29/09] O periodo e o Setor do Relatorio de Faturamento. O Setor nao foi para
            a barra de filtros acima porque ali ele pareceria filtrar o grid. */}
        <ModalRelatorio
          open={modalRelatorioAberto}
          onClose={fecharModalRelatorio}
          titulo={'Relatório de Faturamento'}
          dataInicioInicial={periodoSugerido?.inicio}
          dataFimInicial={periodoSugerido?.fim}
          setores={setores}
          gerando={loadingRelatorio}
          onGerar={gerarRelatorioFaturamento}
        />
        <HeaderComponent
          className={'mb-6'}
          text={'Nota Fiscal'}
          ButtonRight={
            <>
              <Button
                onClick={onSubmit}
                variant='success'
                title={'Status NF'}
                iconStart={<Icon.Sync />}
              />
              <LoadingButton
                loading={loadingRelatorio}
                loadingPosition="start"
                startIcon={<Icon.FileDownload />}
                variant="outlined"
                onClick={downloadRelatorio}
                  sx={{
                  color: '#fff',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1769bb' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                  },
                }}
              >
                <p>Relatório</p>
              </LoadingButton>
              {/* XMLs do periodo em um zip. Fica ao lado do Relatorio porque usa os
                  MESMOS filtros de data - e a validacao e a mesma. */}
              <LoadingButton
                loading={loadingXmls}
                loadingPosition="start"
                startIcon={<Icon.FolderZip />}
                variant="outlined"
                onClick={downloadXmls}
                title="Baixa os XMLs das notas de saída do período: transmitidas e canceladas, respeitando o filtro de Status (máximo de 31 dias)"
                sx={{
                  color: '#fff',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1769bb' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                  },
                }}
              >
                <p>XMLs (zip)</p>
              </LoadingButton>
            </>
          }
        />

        <FormBuilder
          innerRef={formRef}
          fields={fields}
          onSubmit={onSubmit}
          initialValues={{}}
          gap='gap-3'
        />
        <ComponentTable columns={columns} rows={rows} tableHeight={'60vh'} />
      </Box>
    </Loader>
  );
}
